import React from 'react';
import { Icon } from './Icon.js';
export const IconAlignRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "3", width: "11", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "6", y: "10", width: "7", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconAlignRightFill18.js.map